module.exports = __webpack_public_path__ + "img/555-G.574e9f78.png";